import {Component, input, InputSignal} from '@angular/core';
import {AreaForm} from "../../forms/area.form";
import {ReactiveFormsModule} from "@angular/forms";
import {AlertComponent} from "../../../../common/alert/alert.component";

@Component({
  selector: 'app-waste-area-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    AlertComponent
  ],
  templateUrl: './waste-area-form.component.html'
})
export class WasteAreaFormComponent {
  public form: InputSignal<AreaForm | null> = input<AreaForm | null>(null);
}
